import { makeStyles } from '@material-ui/core/styles';
import { Typography, Box } from '@material-ui/core';
import React from 'react'

const useStyles = makeStyles((theme) => ({
    info: {
        padding: '1rem',
        backgroundColor: '#fffceb',
        color: '#2759a5',
        marginBottom: '2rem',
        borderRadius: '8px',
        border: '1px solid #e0e0e0',
    },
    infoText: {
        fontSize: '1.6rem',
        lineHeight: 1.6,
        marginBottom: '1rem',
        color: '#2759a5',
        '&:last-child': {
            marginBottom: 0,
        },
    },
}));

export const InfoBox = ({ children }) => {
    const classes = useStyles();

    return (
        <Box className={classes.info}>
            {React.Children.map(children, (child, index) => {
                if (child.type === 'p') {
                    return (
                        <Typography key={index} variant="body1" className={classes.infoText}>
                            {child.props.children}
                        </Typography>
                    );
                }
                return child;
            })}
        </Box>
    )
}
